import classNames from "classnames"
import { LoadingSpinnerProps } from "./types"
import { Icon } from "../Icon"

export function LoadingSpinner({ className, ...rest }: LoadingSpinnerProps) {
  return <Icon name="SpinnerGap" {...rest} className={classNames("animate-spin", className)} />
}
